// Page d'annulation de paiement Stripe
import { Link, useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { XCircle, ArrowLeft, CreditCard } from 'lucide-react';
import { Button } from '../components/ui/button';

export default function PaymentCancelledPage() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-b from-orange-50 to-white flex items-center justify-center p-4">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        className="max-w-md w-full"
      >
        {/* Logo */}
        <div className="text-center mb-8">
          <Link to="/">
            <img 
              src="https://customer-assets.emergentagent.com/job_organize-smart/artifacts/4450nlnf_abracadabait_logo_transparent.png" 
              alt="AbracadaBati"
              className="h-12 w-auto mx-auto"
            />
          </Link>
        </div>

        <div className="bg-white rounded-2xl shadow-xl p-8 text-center">
          <div className="w-20 h-20 mx-auto mb-6 rounded-full bg-orange-100 flex items-center justify-center">
            <XCircle size={40} className="text-orange-600" />
          </div>
          
          <h1 className="text-2xl font-bold text-gray-900 mb-2">
            Paiement annulé
          </h1>
          
          <p className="text-gray-600 mb-6">
            Vous avez annulé le processus de paiement. 
            Aucun montant n'a été débité de ton compte.
          </p>

          <div className="bg-gray-50 rounded-xl p-4 mb-6">
            <p className="text-sm text-gray-600">
              Vous pouvez reprendre le processus de paiement à tout moment 
              en retournant sur la page des tarifs.
            </p>
          </div>

          <div className="space-y-3">
            <Button
              onClick={() => navigate('/pro/tarifs')}
              className="w-full h-12 bg-orange-600 hover:bg-orange-700"
            >
              <CreditCard size={18} className="mr-2" />
              Voir les tarifs
            </Button>
            
            <Button
              variant="outline"
              onClick={() => navigate('/')}
              className="w-full"
            >
              <ArrowLeft size={18} className="mr-2" />
              Retour à l'accueil
            </Button>
          </div>
        </div>

        <p className="text-center text-sm text-gray-500 mt-6">
          Une question ? <Link to="/contact" className="text-blue-600 hover:underline">Contactez-nous</Link>
        </p>
      </motion.div>
    </div>
  );
}
